import moment from 'moment-jalaali';
import Cookies from "universal-cookie";

import { AUTH_REFRESH, LOGIN, LOGOUT } from "../types";

export const initialState = {
    login: false,
    token: null,
    user: null,
    setting: null,
    expiration: moment().unix()
};

const cookies = new Cookies();

export default function authenticationReducer(state = initialState, action) {
    switch (action.type) {
        case LOGIN:
            cookies.set('auth', action.payload.token, { path: '/', expires: moment().add(1, "year").toDate() });
            return {
                ...state,
                login: true,
                user: action.payload.user,
                token: action.payload.token,
                setting: action.payload.setting,
                expiration: moment().add(1, 'hours').unix(),
            };
        case LOGOUT:
            cookies.remove('auth');
            return {
                ...state,
                user: null,
                token: null,
                setting: null,
                login: false
            };
        case AUTH_REFRESH:
            return {
                ...state,
                user: action.payload,
                expiration: moment().add(1, 'hours').unix(),
            };
        default:
            return state;
    }
}